<template>
   
    <div> 
        <div class="crumbs" hidden="true"  style="margin-left:10px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 产品管理
                </el-breadcrumb-item>
                <el-breadcrumb-item>下载记录</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
          <el-card shadow="hover"  class="searchCard" >
                <span class="label-span">
                    <label class="label">下载人</label> 
                    <el-input v-model.trim="query.loginName" placeholder="下载人" class="handle-input mr15"></el-input> 
                </span>
                <span class="label-span">
                    <label class="label">下载人号码</label> 
                    <el-input v-model.trim="query.phone" placeholder="下载人号码" class="handle-input mr15"></el-input> 
                </span> 
                <span class="label-span">
                    <label class="label">文档名称</label> 
                    <el-input v-model.trim="query.fileName" placeholder="文档名称" class="handle-input mr15"></el-input> 
                </span>  
                <el-button type="success" icon="el-icon-search"  class="mr10"  @click="handleSearch">搜索</el-button>
                <el-button type="error" icon="el-icon-refresh" class="mr10" style="margin-right:25px;"  @click="refreshSearch">重置</el-button>
               <!-- <el-button  type="primary"  icon="el-icon-lx-roundadd" class="mr10"  @click="addBind" >删除日志</el-button> 
               -->
               
          </el-card>
          <el-card shadow="hover"  class="containCard" >
            <el-table :data="tableData" class="table"  ref="multipleTable" header-cell-class-name="table-header"  @selection-change="handleSelectionChange"  >
                <!--<el-table-column type="selection" width="35" align="center"></el-table-column>--> 
                <el-table-column prop="logo" width="80" align="center" label="文件图标">
                    <template slot-scope="scope" >   
                        <img style="width:35px;" v-if="scope.row.fileType=='.xlsx' || scope.row.fileType=='.xls'" :src="require('/src/assets/icon/excel.png')" />
                        <img style="width:35px;" v-else-if="scope.row.fileType=='.pdf'" :src="require('/src/assets/icon/pdf.png')" />
                        <img style="width:35px;"  v-else-if="scope.row.fileType=='.word' || scope.row.fileType=='.doc' || scope.row.fileType=='.docx'" :src="require('/src/assets/icon/word.png')" />
                        <img style="width:35px;" v-else-if="scope.row.fileType=='.jfif' || scope.row.fileType=='.png' || scope.row.fileType=='.jpg' || scope.row.fileType=='.jpeg'  || scope.row.fileType=='.gif'" :src="require('/src/assets/icon/img.png')" />
                        <img style="width:35px;" v-else-if="scope.row.fileType=='.txt'" :src="require('/src/assets/icon/txt.png')" />
                        <img style="width:35px;" v-else-if="scope.row.fileType=='.ppt' || scope.row.fileType=='.pptx'" :src="require('/src/assets/icon/ppt.png')" />
                        <img style="width:35px;"  v-else-if="scope.row.fileType=='.zip' || scope.row.fileType=='.tar' || scope.row.fileType=='.rar' || scope.row.fileType=='.7z' || scope.row.fileType=='.iso'" :src="require('/src/assets/icon/zip.png')" />
                   </template> 
                </el-table-column>     
                <el-table-column prop="loginName" width="120" align="left" label="操作人"> </el-table-column>     
                <el-table-column prop="phone" width="120" align="left" label="操作人号码"> </el-table-column>      
                <el-table-column prop="fileName" min-width="100" align="left" label="文档名称"></el-table-column>    
                <el-table-column prop="fileSize" width="120" align="left" label="文档大小"></el-table-column>     
                <el-table-column prop="createTime" width="160" align="center"  label="文档状态">
                     <template slot-scope="scope">  
                        <el-tag :type="scope.row.delFag==1?'danger':'success'">{{scope.row.delFag==1?'已删除':'正常'}}</el-tag>
                        
                    </template> 
                </el-table-column>  
                <el-table-column prop="link" min-width="120" align="left" label="文档链接"> 
                    <template slot-scope="scope">  
                        <p v-if="scope.row.link!=null && scope.row.link!=''">
                         <el-popover placement="left-start" title="详细信息"  width="500" trigger="hover" :content="scope.row.link">
                            <span style="background:none;color:blue;font-size:12px;white-space: nowrap; text-overflow: ellipsis;" slot="reference" >{{scope.row.link}}</span>
                        </el-popover>
                        </p>
                    </template> 
                </el-table-column>     
                
                <el-table-column prop="createTime" width="165" align="center"  label="下载时间"> </el-table-column> 
                <el-table-column label="操作" width="120" align="right"  >
                    <template slot-scope="scope">    
                        <span class='tableOperBtn' @click="downFile( scope.row.link,scope.row.fileName)" ><i class='el-icon-download'></i> 下载</span> 
                    </template>
                </el-table-column>     
            </el-table>
            <div class="pagination">
                <el-pagination 
                   background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[10, 20, 50]"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange" 
                ></el-pagination>
            </div>
        </el-card> 
        <!-- 新建自主渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="新增分类" :visible.sync="addVisible" :modal-append-to-body='false' top="80px" width="530px">
            <el-form ref="form1" :model="form1" label-width="120px" @submit.native.prevent="saveForm">
                <el-form-item label="产品分类名称">
                    <el-input v-model.trim="form1.name"  placeholder="不超过10个字" style="width:360px;"></el-input>
                </el-form-item> 
                <el-form-item label="产品分类描述">
                    <el-input v-model.trim="form1.descript"  placeholder="不超过20个字" style="width:360px;"></el-input>
                </el-form-item>     
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">{{ isSubmitting ? '提交中...' : '提 交' }}</el-button>
            </span>
        </el-dialog>
         
  

        <!-- 编辑自主渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="编辑分类" :visible.sync="editVisible" :modal-append-to-body='false' top="50px" width="530px">
            <el-form ref="form3" :model="form3" label-width="120px">
                <el-form-item label="产品分类名称">
                    <el-input v-model.trim="form2.name"  placeholder="不超过10个字" style="width:360px;"></el-input>
                </el-form-item> 
                <el-form-item label="产品分类描述">
                    <el-input v-model.trim="form2.descript"  placeholder="不超过20个字" style="width:360px;"></el-input>
                </el-form-item>     
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>
          
    </div>
</template>
<script>
import {fetchData,saveForm,handDelete,changeForm,changeStatus} from '../../api/docDown'; 
export default {

    data() {
        return {  
            isSubmitting: false, // 是否正在提交
            Timeout:'', 
            activeNames:1,
            select:{ option:'',  },
            sendSms:{
                code:'', 
                content:'发送验证码',
                type:'danger',
                disabled:false,
                color:'color:#fff',
             },
            
            query: { 
                pageIndex: 1,
                pageSize: 10,  
            },
            tableData: [],
            tableData2: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            editPlusVisible: false,
            addVisible: false,
            addPlusVisible:false,
            detailVisible:false,  
            row:{},
            pageTotal: 0,
            form: {  
                ids:'',
                names:'',
            },
            form1: {
                ctype:'2',  
            },
            form2: {   },
            form3: {   },
            form4: {   },
            idx: -1,
            id: -1
        };
    },
    created() {
         
    },
    //页面加载方法
    mounted: function () { 
        //查询列表
        this.getData();  
    },

    methods: {  
        // 触发搜索按钮 
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
       
        //文件下载
        downFile(url,name) {
            let fileUrl = url  //服务器文件地址
            this.getBlob(fileUrl).then(blob => {
                this.saveAs(blob, name)
            })
        },
 
        //通过文件下载url拿到对应的blob对象
        getBlob(url) {
            return new Promise(resolve => {
                const xhr = new XMLHttpRequest()
                xhr.open('GET', url, true)
                xhr.responseType = 'blob'
                xhr.onload = () => {
                if (xhr.status === 200) {
                    resolve(xhr.response)
                }
            }
        
            xhr.send()
            })
        },
        //下载文件
        saveAs(blob, filename) {
            var link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = filename
            link.click()
        },

        //重置按钮
        refreshSearch(){ 
            this.$set(this.query, 'phone');  
            this.$set(this.query, 'loginName');    
            this.$set(this.query, 'fileName');      
            this.handleSearch();
        }, 
    

        //触发刷新按钮
        refresh(){
            history.go(0); 
        }, 

        //查询
        getData(){ 
            this.query.stationId = this.stationId;  
            this.query.mid = this.mid;
            this.query.secret = this.secret; 
            fetchData(this.query).then(res => {  
                if(res.code=='200'){ 
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal ;  
                }else{
                    this.tableData = []; 
                    this.pageTotal = 0;
                } 
                
            });
        },
        
        // 新增渠道
        addBind() {
            this.addVisible = true; 
        },
        //保存新增
        saveForm() {   
            if (this.isSubmitting) return;
            this.isSubmitting = true; // 禁用按钮
            if( !this.form1.name ){
                this.isSubmitting = false;
                this.$message.error("请填写分类名称");
                return;
            }  
            this.addVisible = false;
            saveForm(this.form1).then(res => {
                this.isSubmitting = false; 
                if(res.code=='200'){ 
                    this.addPlusVisible = false;
                    this.$message.success(res.message); 
                    this.refreshSearch();
                }else{
                    this.addVisible = true;
                    this.$message.error(res.message); 
                } 
            });
        },

        

        // 编辑操作
        handleEdit(index, row) {      
            this.editVisible = true;
            this.form2 = row; 
        },
 
        
        // 保存更改
        saveEdit() {   
            changeForm(this.form2).then(res => {
                if(res.code=='200'){
                    this.editVisible = false; 
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.$message.error(res.message); 
                }
            });
        },
        // q启用、禁用--改变状态
        handleStatus(index, row) {  
            var tips ;
            var content;
            if(row.status=='0'){ 
                tips = "禁用";
                content = "确定禁用吗？";
            }else{ 
                tips = "启用";
                content = "确定启用吗？"; 
            }
            // 二次确认删除
            this.$confirm(content, '提示', {
                type: 'warning'
            }).then(() => { 
                changeStatus(row).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success(tips+'成功'); 
                        this.getData();
                    }else{ 
                        this.$message.error(tips+'失败');
                    } 
                });
            })
            .catch(() => {}); 
           
        },
 
        
        //详情
        handleDetail(index, row){
            this.form2 = row; 
            if(row.channelType=='1'){
                this.detailVisible = true; 
            }
            
        },
        // 删除
        handDelete(index, row) {  
            this.form.id=row.id; 
            this.form.mid = this.mid;
            this.form.stationId = this.stationId; 
            // 二次确认删除
            this.$confirm('确认删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(this.form).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success('删除成功'); 
                        this.$set(this.query, 'pageIndex', 1); 
                        this.getData();
                    }else{
                        this.$message.error("删除失败"); 
                    } 
                });
            }) 
        },
        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.label{
    background: #eee;
    font-size: 14px;
    height: 32px;
    display: inline-block;
    line-height: 33px;
    width:100px;
    text-align:center;
    color: #555;
  }
  .label-span{
      display: inline-block;
      height: 45px;
  }
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 100px;
    display: inline-block;
}

.handle-input {
    width: 150px;
    display: inline-block;
}
.handle-del {
    float:right; 
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
    margin-left:0;
}
.mr15 {
    margin-right: 15px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
